"use client";

interface SLFontProviderProps {
  children: React.ReactNode;
}

export const SLFontProvider = ({ children }: SLFontProviderProps) => {
  return <>{children}</>;
};
